import { Choice } from './choice';
import { Page } from './page';
import { Survey } from './survey';

class ValueAndText {
  constructor(public Value: string, public Text: string) {}
}

export class Question {
  id: number;
  key: string;
  text: string;
  text_pretty: string;
  subtext: string;
  subtext_pretty: string;
  order: number;
  required: boolean;
  mapped: boolean;
  page_id: number;
  survey_id: number;
  rows: number;
  columns: number;
  group: string;
  type: string;
  no_heading: boolean = false;

  range_from: number;
  range_to: number;
  is_select: boolean = false;

  // fixme not all fields are mapped

  private _survey: Survey;

  getSurvey(): Survey {
    return this._survey;
  }

  setSurvey(survey: Survey) {
    this._survey = survey;
  }

  private _page: Page;

  getPage(): Page {
    return this._page;
  }

  setPage(page: Page) {
    this._page = page;
  }

  labels: any;
  private choices: any;
  private _choices: Choice[] = [];

  getChoices(): Choice[] {
    return this._choices;
  }

  setChoices(choices: Choice[]) {
    this._choices = choices;
  }

  getSelectOptions(): ValueAndText[] {
    // fixme this function seems to be called many times by angular
    // investigate why?
    let options: ValueAndText[] = [];
    if (this.type === 'integer' && this.is_select) {
      options.push(new ValueAndText('__nochoice', 'Select...')); // fixme translation of Select...
      if (this.range_from < this.range_to)
        for (var r: number = this.range_from; r <= this.range_to; r++) {
          options.push(new ValueAndText(r.toString(), r.toString()));
        }
      else {
        for (var r: number = this.range_from; r >= this.range_to; r--) {
          options.push(new ValueAndText(r.toString(), r.toString()));
        }
      }
    } else if (this.type === 'single-choice' && this.is_select) {
      options.push(new ValueAndText('__nochoice', 'Select...')); // fixme translation of Select...
      for (let choice of this.getChoices()) {
        options.push(new ValueAndText(choice.value, choice.text_pretty));
      }
    }
    return options;
  }

  isGroupedQuestion(): boolean {
    return this.group != null;
  }

  isFirstQuestionInGroup(): boolean {
    if (!this.group) return false;

    let grouped_questions: Question[] = this.getAllQuestionsInGroup();
    if (grouped_questions.length == 0) return false;

    return grouped_questions[0].id == this.id;
  }

  getAllQuestionsInGroup(): Question[] {
    if (this.group == null) {
      return [];
    }
    return this._page.getGroupedQuestionsMap()[this.group];
  }

  getAllChoicesInGroup(): Choice[] {
    var grouped_choices: Choice[] = [];
    for (let question of this.getAllQuestionsInGroup()) {
      grouped_choices.push.apply(grouped_choices, question.getChoices());
    }
    return grouped_choices;
  }

  isFirstQuestion(): boolean {
    return this.order == 0;
  }

  isLastQuestion(): boolean {
    return this.order == this.getPage().getQuestions().length - 1;
  }

  toJSON(): Object {
    // create an instance of the Question class
    let question = Object.create(Question.prototype);
    // copy all the fields to the json object
    question.key = this.key;
    question.text = this.text;
    question.type = this.type;

    return question;
  }

  static fromJSON(question_json: Object): Question {
    // create an instance of the Question class
    let question = Object.create(Question.prototype);
    // copy all the fields from the json object
    let obj = Object.assign(question, question_json, {
      // convert fields that need converting
      // created: new Date(json.created),
    });

    let choices_json = question.choices;
    let _choices: Choice[] = [];

    for (let choice_json of choices_json) {
      let choice = Choice.fromJSON(choice_json);
      _choices.push(choice);
    }
    let plabels = [];
    question.setChoices(_choices);
    for (let choice of question.choices) {
      plabels.push(choice.text_pretty);
    }
    question.labels = plabels;
    delete question.choices;
    return question;
  }
}
